import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { SafeAreaView } from "@/components/ui/safe-area-view";
import { ScrollView } from "@/components/ui/scroll-view";
import { Image } from "@/components/ui/image";
import { PropsWithChildren } from "react";
import Logo from "@/screens/menu/logo/logo";
import { ImageBackground } from "@/components/ui/image-background";
import { Box } from "@/components/ui/box";

type AuthLayoutProps = PropsWithChildren & {};

export function AuthLayout(props: AuthLayoutProps) {
  return (
    <SafeAreaView className="w-full h-full bg-background-0">
      <ScrollView
        className="w-full h-full"
        contentContainerStyle={{ flexGrow: 1 }}
        alwaysBounceVertical={false}
      >
        <HStack className="w-full h-full bg-background-0 flex-grow justify-center">
          <Box className="relative hidden md:flex h-full w-full flex-1 items-center justify-center">
            <Image
              height="100%"
              width="100%"
              source={require("@/assets/auth/radialGradient.png")}
              className="object-cover h-full w-full"
              alt="Hoteza Background"
            />
            <Box className="absolute w-full flex items-center justify-center">
              <Logo
                width="70%"
                height="100"
                color="white"
                fill="white"
                className="max-w-96"
              />
            </Box>
          </Box>
          <VStack className="md:items-center md:justify-center flex-1 w-full  p-9 md:gap-10 gap-16 md:m-auto md:w-1/2 h-full">
            {props.children}
          </VStack>
        </HStack>
      </ScrollView>
    </SafeAreaView>
  );
}
